export enum TermsAndConditions {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Verifone = 'Verifone',
}
